export default __webpack_public_path__ + "static/media/placeholder_jeans.2a0fdfbe.svg";